import { render, staticRenderFns } from "./TranscriptsDetails.vue?vue&type=template&id=23fead6e&scoped=true&"
import script from "./TranscriptsDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./TranscriptsDetails.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TranscriptsDetails.vue?vue&type=style&index=0&id=23fead6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fead6e",
  null
  
)

export default component.exports